import Model from 'flarum/common/Model';
export default class Fish extends Model {
  round_id = Model.attribute('round_id'); // Just for the creation apiEndpoint creation
  placement = Model.attribute('placement'); // Object
  name = Model.attribute('name');
  image_url = Model.attribute('image_url');
  canSee = Model.attribute('canSee');
  canCatch = Model.attribute('canCatch');
  canName = Model.attribute('canName');
  canPlace = Model.attribute('canPlace');
  placeUntil = Model.attribute('placeUntil');
  namedBy = Model.hasOne('lastUserNaming');
  placedBy = Model.hasOne('lastUserPlacement');
  round = Model.hasOne('round');
  placementModel = Model.hasOne('placementModel'); // Only used by the admin panel to show the link to the resource

  apiEndpoint() {
    return this.exists ? '/catchthefish-fishes/' + this.data.id : '/catchthefish-rounds/' + this.data.attributes.round_id + '/fishes';
  }
}
flarum.reg.add('clarkwinkelmann-catch-the-fish', 'common/models/Fish', Fish);